import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Dlog } from "./../../../../utils/Dlog";

import HttpContext from "../../../../contexts/HTTP/HttpContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";
import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { useNavigate } from "react-router-dom";

import { Translate, Localize, translate } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
import QRCode from "react-qr-code";

import { IdleTimerContext, IdleTimerProvider } from "react-idle-timer";

import IdleTimerDisplay from "./../Shared/IdleTimerDisplay_V";
import LanguageButtons from "./../Shared/LanguageButtons";
import PhoneKeypad from "./../CustomerPhoneNumber/PhoneKeypad";
import PhoneConfirm from "./../CustomerPhoneNumber/PhoneConfirm";
import PhoneDisplay from "./../CustomerPhoneNumber/PhoneDisplay_V";
import BackspaceButton from "./../CustomerPhoneNumber/BackspaceButton";
import CircleButton from "./../Buttons/CircleButton_V";

import KioskDetail from "./../../Components/Shared/KioskDetail";
import FlexLeftPanel from "./../../Components/Shared/PanelElements/FlexLeftPanel";
import FlexRightPanel from "./../../Components/Shared/PanelElements/FlexRightPanel";
import SubtitleWrapper from "./../../Components/Shared/PanelElements/SubtitleWrapper";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal";

import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";
import { useKioskHorizontalStyles } from "./../../../../kioskstyles";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";

import PrintIcon from "@mui/icons-material/Print";

import KioskStepper from "./../../Components/Stepper/KioskStepper";
import Logo from "./../../Components/Logo";

import formatFirstNameLastInitial from "./../../HelperFunctions/formatFirstNameLastInitial";
import formatAddress from "./../../HelperFunctions/formatAddress";

import { useTheme } from "@mui/material/styles";

import { WORKFLOW_MODES } from "../../../../constants";

let env = require("./../../../../env");

function displayError(errorCode) {
  switch (errorCode) {
    case 400:
      return translate("application.phonenumber.errors.unablefetchaccount");
    case 401:
      return translate("application.phonenumber.errors.invalidphone");
    case 404:
      return translate("application.errors.invalidcredentials");
    case 503:
      return translate("application.errors.serverunavailable");
    default:
      return translate("application.errors.unknownerror");
  }
}

export default function HorizontalLayout(props) {
  const {
    setKioskkeyFunc,
    nextFunc,
    loading,
    //errorMessage,
    isNotMobile,
    kioskkey,
    numbagpress,
    getKioskConfiguration
  } = props;

  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    sessionID,
    setAll,
    customerReset
  } = useContext(KioskContext);

  const { getKioskTheme } = useContext(SocketIOContext);

  const { simplepost } = useContext(HttpContext);
  const theme = useTheme();
  const navigate = useNavigate();
  const kioskverticalstyles_2 = useKioskVerticalStyles();
  const kioskstyles = useKioskHorizontalStyles();
  const kioskconfiguration = getKioskConfiguration();

  const [phonenumber, setPhonenumber] = useState("");
  const [showconfirmdialog, setShowconfirmdialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // const keypadDone = async () => {
  //   console.log("next called");

  //   //Attempt Kiosk Login
  //   const res = await simplepost("/kiosk/getCustomer", {
  //     type: "phone",
  //     value: phonenumber
  //   });

  //   //console.log("CPN DEBUG res.data", res.data);

  //   //var customerName = res.data.name;
  //   var customerFirstName = res.data.firstName;
  //   var customerLastName = res.data.lastName;
  //   var customerID = res.data.uniqueID;

  //   if (res.status >= 400) {
  //     setErrorMessage(displayError(res.status));
  //     return;
  //   }

  //   setAll(
  //     //customerName, //customerName
  //     customerFirstName, //customerFirstName
  //     customerLastName, //customerLastName
  //     customerID, //customerID
  //     null, //numBags
  //     null, //numLabels
  //     null, //labelsList
  //     sessionID //sessionID
  //   );

  //   setErrorMessage("");
  //   setShowconfirmdialog(true);
  // };

  const hideConfirmDialog = async () => {
    setPhonenumber("");
    setShowconfirmdialog(false);
  };

  const displaystyleForconfirmdialog = async () => {
    Dlog("displaystyleForconfirmdialog", showconfirmdialog);

    if (showconfirmdialog) {
      return { display: "none" };
    } else {
      return { display: "block" };
    }
  };

  const backspacepress = async () => {
    let newNumber = phonenumber;

    if (newNumber.length > 0) {
      newNumber = newNumber.substring(0, newNumber.length - 1);
    }

    setPhonenumber(newNumber);
  };

  const next = async () => {
    navigate("/numbags");
  };

  const onIdle = async () => {
    if (env.IDLETIMER) {
      const kiosktheme = getKioskTheme();
      if (kiosktheme.bilingual) {
        setLocale("fr");
      }

      navigate("/language");
    }
  };

  const locationAddress = localStorage.getItem("LocationAddress");
  const locationName = localStorage.getItem("LocationName");

  let activeStepNum = kioskconfiguration?.workflowmode;

  return (
    <IdleTimerProvider timeout={30000} onIdle={onIdle}>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        style={kioskstyles.GridFullHeightFix}
      >
        <FlexLeftPanel isNotMobile={isNotMobile}>
          <div style={kioskstyles.flexLeftPanelContents}>
            <div style={kioskstyles.flexParentPanel}>
              <div style={kioskstyles.flexPanelLayoutB_TopContainer}>
                <Logo />
              </div>
              <div style={kioskstyles.flexPanelLayoutB_MidContainer}>
                <div style={kioskstyles.kioskDetails}>
                  <div
                    class="fontSecondaryText"
                    style={kioskstyles.whiteSubtitleText}
                  >
                    <Translate
                      value="application.theme.wizardThanksText"
                      name={formatFirstNameLastInitial(
                        customerFirstName,
                        customerLastName
                      )}
                    />
                  </div>
                  <br />
                  <KioskDetail getKioskConfiguration={getKioskConfiguration} />
                  <br />
                  <div
                    class="fontSecondaryText"
                    style={{
                      ...kioskstyles.whiteBodyText,
                      ...kioskstyles.kioskDetailsSpaceBetween
                    }}
                  >
                    {/* <Translate
                      value="application.kioskdetail.returningnumbags"
                      count={numBags}
                    /> */}
                    <Translate value="application.theme.wizardReturningText" />{" "}
                    <b>
                      <Translate
                        value="application.theme.wizardBagsText"
                        count={numBags}
                      />
                    </b>
                  </div>

                  {kioskconfiguration?.workflowMode ==
                    WORKFLOW_MODES.BAGS_AND_LABELS && (
                    <>
                      <br />
                      <div
                        class="fontSecondaryText"
                        style={{
                          ...kioskstyles.whiteBodyText,
                          ...kioskstyles.kioskDetailsSpaceBetween
                        }}
                      >
                        <Translate value="application.theme.wizardPrintingText" />{" "}
                        <b>
                          <Translate
                            value="application.theme.wizardLabelsText"
                            count={numLabels}
                          />
                        </b>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div style={kioskstyles.flexPanelLayoutB_BotContainer}>
                <KioskStepper
                  activeStep={2}
                  backUrl={"/numbags"}
                  workflowmode={kioskconfiguration?.workflowmode}
                  getKioskConfiguration={getKioskConfiguration}
                />
              </div>
            </div>
          </div>
        </FlexLeftPanel>
        <FlexRightPanel isNotMobile={isNotMobile}>
          <div
            style={{
              ...kioskstyles.flexRightPanelContents,
              display: "flex",
              flexDirection: "column",
              height: "100%"
            }}
          >
            <div
              style={{
                ...kioskstyles.flexParentPanel,
                fontSize: "clamp(4.5px, 3.2vh, 28px)"
              }}
            >
              <div style={kioskstyles.flexPanelLayoutB_TopContainer}>
                <SubtitleWrapper isNotMobile={isNotMobile}>
                  <Translate value="application.theme.printTitleText" />
                </SubtitleWrapper>
              </div>
              <br />
              <div>
                <center>
                  <PrintIcon
                    style={{ fontSize: "clamp(70px, 16.67vw, 300px)" }}
                  />
                </center>
              </div>
            </div>
          </div>
        </FlexRightPanel>
      </Grid>
      <IdleTimerDisplay />
      <PrinterConnectionModal />
    </IdleTimerProvider>
  );
}
